module.exports = __webpack_public_path__ + "static/images/icon-movie-new4.e58593b.png";